import { useContext } from 'react';
import languageContext from '@/context/language';
import { useTranslation } from '@/app/i18n/client';

export enum NAMESPACE {
  checkout = 'checkout',
  cart = 'cart',
  common = 'common',
  pdp = 'pdp',
  favorites = 'favorites',
  structureSearch = 'structureSearch',
  miniCart = 'miniCart',
  paymentHistory = 'payment-history',
  skuNotes = 'sku-notes',
  quickOrder = 'quick-order',
  stockManagement = 'stock-management',
  adminOrderManagement = 'admin-order-management',
  requestForm = 'request-form',
  customBulk = 'custom-bulk',
  adminDropShip = 'admin-drop-ship',
  search = 'search',
  adminPromotion = 'admin-promotion',
  promotion = 'promotion',
  orderHistory = 'orderhistory',
  downloadQuotation = 'download-quotation',
  consolidatedInvoice = 'consolidated-invoice',
  dispatchNote = 'dispatch-note',
  invoice = 'invoice',
  paymentList = 'payment-list',
  cancelOrder = 'cancel-order',
  orderDelivery = 'order-delivery',
  baseNumber = 'base-number',
  documentSearch = 'document-search',
}

export const useLang = (namespace: NAMESPACE) => {
  const { lang } = useContext(languageContext);
  const translation = useTranslation(lang, namespace);
  return {
    ...translation,
    lang,
  };
};
